import { useState } from "react";
import { Formik, Form as FormikForm } from "formik";
import { useChangePassword } from "../../../../hooks/tenant/useChangePassword";
import ChangePasswordModal from "../../../common/ChangePasswordModal";
import CustomInput from "../../../common/CustomInput";

export const SettingFormRow = ({ users }) => {
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [passwordSuccess, setPasswordSuccess] = useState(false);

  const {
    changePassword,
    loading: passwordLoading,
    error: passwordError,
    setError,
  } = useChangePassword();

  const initialValues = {
    name: users?.name || "N/A",
    username: users?.username || "N/A",
    email: users?.email || "N/A",
  };

  const handleOpenPasswordModal = () => {
    setPasswordSuccess(false);
    setShowPasswordModal(true);
    setError("");
  };

  const handleClosePasswordModal = () => {
    setShowPasswordModal(false);
    setPasswordSuccess(false);
    setError("");
  };

  const handleChangePassword = async (values) => {
    const success = await changePassword({
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    });

    if (success) {
      setPasswordSuccess(true);
      // Close modal after 2 seconds on success
      setTimeout(() => {
        handleClosePasswordModal();
      }, 2000);
    }

    return success;
  };

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={() => { }}>
        <FormikForm className="mt-4">
          {/* Name */}
          <div className="mb-3 row">
            <label className="col-form-label col-12 col-md-3 addSchlAcuntFormLabel d-none d-md-block">
              Name
            </label>
            <div className="col-12 col-md-9">
              <CustomInput
                name="name"
                label="Name"
                showAstreisk={false}
                disabled
                layout="stacked"
                labelClassName="d-md-none"
              />
            </div>
          </div>


          {/* Email */}
          <div className="mb-3 row">
            <label className="col-form-label col-12 col-md-3 addSchlAcuntFormLabel d-none d-md-block">
              Email
            </label>
            <div className="col-12 col-md-9">
              <CustomInput
                name="email"
                label="Email"
                showAstreisk={false}
                disabled
                layout="stacked"
                labelClassName="d-md-none"
              />
            </div>
          </div>

          {/* Change Password Button */}
          <div className="mt-4">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handleOpenPasswordModal}
            >
              <i className="bi bi-key me-2"></i>
              Change Password
            </button>
          </div>
        </FormikForm>
      </Formik>

      {/* Change Password Modal */}
      {showPasswordModal && (
        <ChangePasswordModal
          showModal={showPasswordModal}
          handleClose={handleClosePasswordModal}
          handleChangePassword={handleChangePassword}
          loading={passwordLoading}
          error={passwordError}
          success={passwordSuccess}
        />
      )}
    </>
  );
};
